<template>
<!-- Cubrid는 데몬프로세스와 DB 세션 동일한 컴포넌트 사용 -->
<div>
  <el-row class="title-bar" type="flex" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
    <div>
      <!-- TODO: 큐브리드 데몬 프로세스 스냅샷 BE 구현 후 이력 제공 필요 -->
      <w-perf-analysis-time-info v-if="!operationFlag" fixed-time-type="current" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad"/>
    </div>
    <div>
      <div class="vertical-center-box" style="display:inline-block;">
        <el-radio-group class="mr-r10" v-model="selectedDataType" @change="onDataTypeChange">
          <el-radio :label="dataTypes.CAS">CAS</el-radio>
          <el-radio :label="dataTypes.BROKER">브로커</el-radio>
        </el-radio-group>
      </div>
      <w-header-search-button @click="onSearchToolButtonClick"></w-header-search-button>
    </div>
  </el-row>
  <div v-loading="isLoading">
    <!-- CAS -->
    <el-table-wrapper v-show="selectedDataType === dataTypes.CAS" :data="casTableData" :columns="casColunms" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showCasSearchTool">
    </el-table-wrapper>
    <!-- Broker -->
    <el-table-wrapper v-show="selectedDataType !== dataTypes.CAS" :data="brokerTableData" :columns="brokerColumns" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showBrokerSearchTool">
    </el-table-wrapper>
  </div>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import databaseTableInfoAPI from '@/api/performance/database/database-table-info';
import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import { analysisTimeType } from '@/constants/performance';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import AnalysisTableMixin from '@/mixins/performance/analysis-table-ex';

const DEFAULT_TIME_TYPE = analysisTimeType.CURRENT.value;
export default {
  name: 'WDemonprocessCubridTable',
  mixins: [AnalysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      /* common */
      dataTypes: {
        CAS: 'CAS',
        BROKER: 'broker',
      },
      selectedDataType: 'CAS',
      defaultTimeType: DEFAULT_TIME_TYPE,
      timeType: DEFAULT_TIME_TYPE,
      isLoading: false,
      columnDefault,
      checkDatetime: null,
      /* cas */
      casTableData: [],
      showCasSearchTool: false,
      casColunms: [
        { prop: 'BROKERNAME', label: '브로커명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'PID', label: '프로세스 ID', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'PORT', label: '페이지 사이즈', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'STATUS', label: '프로세스 상태', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'HOST', label: '호스트 명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'DB', label: 'DB 명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'CLINETIP', label: '클라이언트 IP', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'CLIENTVERSION', label: '클라이언트 버전', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'QPS', label: '쿼리 수', sortable: true, formatter: this.formmaterForCount },
        { prop: 'LQS', label: '장기 실행 쿼리 수', sortable: true, formatter: this.formmaterForCount },
        { prop: 'CONNECT', label: '클라이언트 접근 수', sortable: true, formatter: this.formmaterForCount },
        { prop: 'SQLLOGMODE', label: 'SQL LOG 모드', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'TRASCATIONTIME', label: '트랜잭션 시작 시각', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'LASTACESSTIME', label: 'CAS 접근 시각', sortable: true, searchable: true, searchType: 'date', formatter: this.formatterForDatetime },
        { prop: 'LASTCONNECTIONTIME', label: '서버 접근 시각', sortable: true, searchable: true, searchType: 'date', formatter: this.formatterForDatetime },
      ],
      /* broker */
      brokerTableData: [],
      showBrokerSearchTool: false,
      brokerColumns: [
        { prop: 'PID', label: '프로세스ID', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'NAME', label: '프로세스 이름', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'PSIZE', label: '프로세스 크기', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'PORT', label: '포트', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'JQ', label: '대기 작업 수', sortable: true, formatter: this.formmaterForCount },
        { prop: 'TPS', label: '트랜잭션 수', sortable: true, formatter: this.formmaterForCount },
        { prop: 'QPS', label: '쿼리 수', sortable: true, formatter: this.formmaterForCount },
        { prop: 'LONG-T', label: 'LONG 트랜잭션 수', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'LONG-Q', label: 'lONG 쿼리 수', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'ERR-Q', label: '에러 쿼리 수', sortable: true, formatter: this.formmaterForCount },
        { prop: 'UNIQUE-ERR-Q', label: '특이 에러 쿼리 수', sortable: true, formatter: this.formmaterForCount },
        { prop: 'CANCELED', label: '취소 쿼리 수', sortable: true, formatter: this.formmaterForCount },
        { prop: 'ACCESS_MODE', label: '접근 모드', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'SQL_LOG', label: 'SQL LOG', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: '#CONNECT', label: '클라이언트 접근 수', sortable: true, formatter: this.formmaterForCount },
      ],
    };
  },
  methods: {
    /**
     * 데몬 프로세스 데이터를 조회한다.
     * @author Ju
     */
    loadData() {
      if (this.selectedDataType === this.dataTypes.CAS) {
        this.loadCasData();
      } else {
        this.loadBrokerData();
      }
    },
    /**
     * CAS 데이터를 조회환다.
     * @author Ju
     */
    loadCasData() {
      const params = this.getCommonParams();
      params.queryId = 'CUBrokerStatusF';
      this.isLoading = true;
      databaseTableInfoAPI.getCurrentCubridList(params).then((result) => {
        if (result.data.success === true) {
          this.casTableData = result.data.data;
        } else {
          this.failToLoadCas();
        }
      }).catch(() => {
        this.failToLoadCas();
      }).finally(() => {
        this.isLoading = false;
      });
      // TODO: 추후 스냅샷 개발 시 시간 타입에 따라 API 호출 개발 필요.
    },
    /**
     * Broker 데이터를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadBrokerData() {
      const params = this.getCommonParams();
      params.queryId = 'CUBrokerStatusBF';
      databaseTableInfoAPI.getCurrentCubridList(params).then((result) => {
        if (result.data.success === true) {
          this.brokerTableData = result.data.data;
        } else {
          this.brokerTableData = [];
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '데몬 프로세스', false));
      }).finally(() => {
        this.isLoading = false;
      });
      // TODO: 추후 스냅샷 개발 시 시간 타입에 따라 API 호출 개발 필요.
    },
    /**
     * CAS 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadCas() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '데몬 프로세스', false));
      this.casTableData = [];
    },
    /**
     * Broker 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadBroker() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '데몬 프로세스', false));
      this.brokerTableData = [];
    },
    /**
     * 공통 파라미타를 반환한다.
     * @author Ju
     */
    getCommonParams() {
      return {
        objId: this.selectedNode.obj.objId,
        baselineDatetime: this.operationFlag ? new Date().getTime() : this.plotLineDatetime,
        managetypeId: 'DBMS',
      };
    },
    /**
     * Count Formatter
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    formatterForCount(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null, true);
    },
    /**
     * Datetime Formatter
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    formatterForDatetime(row, column, value) {
      if (!isNil(value)) {
        const resultValue = `${value.substring(0, 10)} ${value.substr(10, 8)}`;
        return resultValue.replace(/\//gi, '-');
      }
      return EMPTY_TEXT;
    },
    /**
     * 검색 버튼 클릭 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onSearchToolButtonClick() {
      if (this.selectedDataType === this.dataTypes.CAS) {
        this.showCasSearchTool = !this.showCasSearchTool;
      } else {
        this.showBrokerSearchTool = !this.showBrokerSearchTool;
      }
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 데이터 타입 변경 이벤트 핸들러
     * @author Ju
     */
    onDataTypeChange() {
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/table/DemonProcess/DemonprocessCubridTable.vue